
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },
  head() {
    return {
      title: "Comprendre le SEO en 8 minutes",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous avez très certainement déjà entendu parler du SEO (en anglais) ou du référencement naturel (en français). Mais connaissez-vous réellement son importance pour votre site Internet et votre présence en ligne ?",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comprendre le SEO en 8 minutes",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous avez très certainement déjà entendu parler du SEO (en anglais) ou du référencement naturel (en français). Mais connaissez-vous réellement son importance pour votre site Internet et votre présence en ligne ?",
        },
      ],
    };
  },
};
